import React from "react";
import ContactForm from "../../components/contact/ContactForm";
import AboutUsMap from "../../components/aboutUsMap/AboutUsMap";

const ContactPage = () => {
  return (
    <div>
      <h1>Contact Us</h1>
      <ContactForm />
      <AboutUsMap />
    </div>
  );
};

export default ContactPage;
